import axios from 'axios'
let apiUrl ='https://journalism.lynyn.cn/api/v1/'
let isTokenExpired = false
const linyuanApiBase = process.env.REACT_APP_LINYUAN_API_BASE || 'http://192.168.110.41:3005'

export const linyuanApi = axios.create({
  baseURL: (linyuanApiBase || '') + '/api',
  timeout: 10000
})

linyuanApi.interceptors.response.use(
  (response) => {
    const data = response.data
    if (data && typeof data.code === 'number' && data.code !== 200) {
      const err = new Error(data.message || '请求失败')
      err.response = response
      return Promise.reject(err)
    }
    return data
  },
  (error) => Promise.reject(error)
)

export async function getNewsListFromLinyuan(currentPage, pageSize, type, lang = 0) {
  const params = {
    currentPage,
    pageSize,
    type,
    lang,
    published: 1,
    active: 1
  }
  const res = await linyuanApi.get('/news', { params })
  const apiData = res || {}
  const page = apiData.data || {}
  const list = (page.list || []).map(item => {
    const langValue = typeof item.lang === 'number' ? item.lang : Number(item.lang || 0)
    const title = item.title || (langValue === 0 ? item.title_cn : item.title_en) || item.title_cn || item.title_en || ''
    const cover = item.cover_url || ''
    const contentHtmlUrl = item.content_html_url || ''
    const detailSlug = item.detail_slug || ''

    let coverUrl = cover
    if (cover && !(cover.startsWith('http://') || cover.startsWith('https://'))) {
      coverUrl = `/images/news/${detailSlug}/${cover}`
    }

    return {
      id: item.id,
      lang: langValue,
      title,
      titleCn: item.title_cn,
      titleEn: item.title_en,
      summary: item.summary || '',
      type: item.type,
      publicationDate: item.publication_date,
      detailUrl: detailSlug,
      coverUrl,
      contentHtmlUrl
    }
  })
  return {
    list,
    totalCount: page.totalCount || list.length,
    currentPage: page.currentPage || currentPage,
    pageSize: page.pageSize || pageSize
  }
}

export async function getEmployeesFromLinyuan(currentPage = 1, pageSize = 100, lang = 0) {
  const params = {
    currentPage,
    pageSize
  }
  const res = await linyuanApi.get('/employees', { params })
  const apiData = res || {}
  const page = apiData.data || {}
  const list = (page.list || []).map(item => {
    const avatarFile = item.avatar_url || 'avt00.png'
    let products = []
    const rawProducts = item.products
    if (Array.isArray(rawProducts)) {
      products = rawProducts
    } else if (typeof rawProducts === 'string' && rawProducts.trim() !== '') {
      try {
        const parsed = JSON.parse(rawProducts)
        if (Array.isArray(parsed)) {
          products = parsed
        } else {
          products = rawProducts.split(',').map(p => p.trim()).filter(p => p)
        }
      } catch (e) {
        products = rawProducts.split(',').map(p => p.trim()).filter(p => p)
      }
    }
    const name = lang === 0 ? item.name_cn : item.name_en
    const location = lang === 0 ? item.location_cn : item.location_en
    const position = lang === 0 ? item.position_cn : item.position_en
    const division = lang === 0 ? item.division_cn : item.division_en
    return {
      id: item.id,
      avatar: `/images/contacts/${avatarFile}`,
      name,
      location,
      position,
      division,
      products,
      email: item.email || '',
      mobile: item.mobile || ''
    }
  })
  return {
    list,
    totalCount: page.totalCount || list.length,
    currentPage: page.currentPage || currentPage,
    pageSize: page.pageSize || pageSize
  }
}

export async function getOfficesFromLinyuan(currentPage = 1, pageSize = 100, lang = 0) {
  const params = {
    currentPage,
    pageSize,
    active: 1
  }
  const res = await linyuanApi.get('/offices', { params })
  const apiData = res || {}
  const page = apiData.data || {}
  const list = (page.list || []).map(item => {
    let pics = []
    const rawPics = item.pics
    if (Array.isArray(rawPics)) {
      pics = rawPics
    } else if (typeof rawPics === 'string' && rawPics.trim() !== '') {
      try {
        const parsed = JSON.parse(rawPics)
        if (Array.isArray(parsed)) {
          pics = parsed
        } else {
          pics = rawPics.split(',').map(p => p.trim()).filter(p => p)
        }
      } catch (e) {
        pics = rawPics.split(',').map(p => p.trim()).filter(p => p)
      }
    }
    const add = lang === 0 ? item.address_cn : item.address_en
    const center = {
      lng: item.longitude,
      lat: item.latitude
    }
    return {
      id: item.id,
      center,
      addCN: item.address_cn,
      addEN: item.address_en,
      add,
      pic: pics
    }
  })
  return {
    list,
    totalCount: page.totalCount || list.length,
    currentPage: page.currentPage || currentPage,
    pageSize: page.pageSize || pageSize
  }
}

export async function getPartnerCompaniesFromLinyuan(currentPage = 1, pageSize = 100) {
  const params = {
    currentPage,
    pageSize,
    isPartner: 1,
  };
  const res = await linyuanApi.get('/companies', { params });
  const apiData = res || {};
  const page = apiData.data || {};
  const list = (page.list || []).map((item) => {
    return {
      id: item.id,
      alias: item.alias,
      nameCn: item.name_cn,
      nameEn: item.name_en,
      logoUrl: item.logo_url || '',
      isPartner:
        typeof item.is_partner === 'number'
          ? item.is_partner
          : Number(item.is_partner || 0),
    };
  });
  return {
    list,
    totalCount: page.totalCount || list.length,
    currentPage: page.currentPage || currentPage,
    pageSize: page.pageSize || pageSize,
  };
}



//获取新闻列表
export async function getNewsList(orderBy, pageNo, pageSize, type, language, author){
  //1. 检查本地吃否存在token
  if (localStorage.getItem('token') === null) {
    //2. 取回最新token
    console.log('0. no token found in the local, begin fetching')
    await getNewToken();
    console.log('0.1 token fetched: ', localStorage.getItem('token'))
  } 
  console.log('1. local token found')
    //3. 尝试查询新闻列表
    console.log('2. try to fetch NewsList')
    let res = await getListData(orderBy, pageNo, pageSize, type, language, author)
    if (isTokenExpired) { //如果token过期
      console.log('2.1. token expired, begin to fetch new token')
      //4. 重新获取token
      await getNewToken();
      console.log('2.2. new token fetched: ', localStorage.getItem('token'))
      //5. 重新采用新的token查询新闻列表
      console.log('2.3. retry fetch NewsList')
      res = await getListData(orderBy, pageNo, pageSize, type, language, author);
      console.log('2.4. NewsList fetched')
    }
    return res
}

//通过API查询新闻列表Data
function getListData(orderBy, pageNo, pageSize, type, language, author) {
  //返回Promise对象
  return new Promise ((resolve, reject) => {
    let url = (
      apiUrl + "/journalism/listPageReleasedJournalism?orderBy=" +
        orderBy +
        "&orderType=DESC&pageNo=" +
        pageNo +
        "&pageSize=" +
        pageSize +
        "&type=" +
        type +
        "&language=" +
        language +
        "&author=" +
        author
    )
    // axios采用GET查询
    axios.get(
      url,
      {
        headers: {token: localStorage.getItem('token')}
      }
    ).then((res) => {
      isTokenExpired = false  //预设token过期为false
      console.log('res: ', res)
      if (res.data.msg === '请求成功') { //查询成功
        console.log("News List Data obtained: ", res)
        resolve(res)
      } else {  //token失效，应尝试重新获取
        isTokenExpired = true
        resolve()
      }
    }).catch((err) => { //查询错误
      console.log('Error occurs when fetching NewsList Data')
      reject(err)
    })
  })
}




//获取新闻详情
export async function getNewsDetail(id){
  //1. 检查本地吃否存在token
  if (localStorage.getItem('token') === null) {
    //2. 取回最新token
    console.log('0. no token found in the local, begin fetching')
    await getNewToken();
    console.log('0.1 token fetched: ', localStorage.getItem('token'))
  } 
  console.log('1. local token found')
    //3. 尝试查询新闻详情
    console.log('2. try to fetch NewsDetail')
    let res = await getNewsDetailData(id)
    if (isTokenExpired) { //如果token过期
      console.log('2.1. token expired, begin to fetch new token')
      //4. 重新获取token
      await getNewToken();
      console.log('2.2. new token fetched: ', localStorage.getItem('token'))
      //5. 重新采用新的token查询新闻列表
      console.log('2.3. retry fetch NewsDetail')
      res = await getNewsDetailData(id);
      console.log('2.4. NewsDetail fetched',res)
    }
    return res
}

//通过API查询新闻详情
function getNewsDetailData(id) {
  //返回Promise对象
  return new Promise ((resolve, reject) => {
    let url = (
      apiUrl + "/journalism/listPageJournalismDetails?id=" +
        id
    )
    // axios采用GET查询
    axios.get(
      url,
      {
        headers: {token: localStorage.getItem('token')}
      }
    ).then((res) => {
      isTokenExpired = false  //预设token过期为false
      console.log('res: ', res)
      if (res.status === 200) { //查询成功
        console.log("News detail Data obtained: ", res);
        if(res.data.httpCode === 401&& res.data.msg === '未经授权的accessToken失效或者过期'){
          isTokenExpired = true
        }
        resolve(res)
      } else {  //token失效，应尝试重新获取        
        isTokenExpired = true
        resolve()
      }
    }).catch((err) => { //查询错误
      console.log('Error occurs when fetching NewsDetail Data')
      reject(err)
    })
  })
}


//通过API获取token
function getNewToken() {
  localStorage.removeItem('token');
  //返回Promise对象
  return new Promise((resolve, reject) => {
    var param = {
      password: 123123,
      userName: "root",
    };
    // axios采用POST查询
    axios.post(
      apiUrl + "/user/login",
      param
    ).then((res) => {
      // 获取成功，将token写入localStorage
      console.log('token success: ',res)
      localStorage.setItem('token', res.data.data.token);
      resolve(res.data.data)
    }).catch((err) => {
      // 获取失败，提示错误信息
      console.log('error occurs: ', err)
      reject(err)
    })
  }) 
}


//获取浏览器参数
export function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]); return null;
}
//日期格式化
export function dateFormat(fmt, date) {
  let ret;
  const opt = {
    'Y+': date.getFullYear().toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'M+': date.getMinutes().toString(), // 分
    'S+': date.getSeconds().toString(), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt);
    if (ret) {
      fmt = fmt.replace(ret[1], ret[1].length === 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'));
    }
  }
  return fmt;
}

//用法
// let date = new Date()
// dateFormat("YYYY-mm-dd HH:MM", date)
// >>> 2019-06-06 19:45`
